import { render, staticRenderFns } from "./SpinnerTextAlign.vue?vue&type=template&id=6db26ab2&"
import script from "./SpinnerTextAlign.vue?vue&type=script&lang=js&"
export * from "./SpinnerTextAlign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports